import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  giftIndicator: {
    defaultMessage: 'Gift',
    description: 'orderDetails.thisIsAGift',
    id: 'bJmhKn',
  },
});
